import React from 'react';
import cn from 'classnames';

import { If } from 'utils';
import CustomTableHead from './Head';
import CustomTableRow from './Row';
import CustomTableRows from './Rows';
import CustomTableFoot from './Foot';
import CustomTableAddButton from './AddButton';
import Actions from './Actions';
import ActionsDropdown from './ActionsDropdown';
import InfoLink from './InfoLink';

const CustomTable = ({ children, className = '', isCardType = false }) => {
  return (
    <div
      className={cn('CustomTable-section--table', className, {
        'card-rows': isCardType
      })}
    >
      {children}
    </div>
  );
};

const CustomTableSection = ({
  id = '',
  title,
  children,
  style,
  customClass = ''
}) => {
  return (
    <div
      id={id}
      style={style}
      className={cn('CustomTable-section', customClass)}
    >
      <If test={title}>
        <h5 className="CustomTable-section--heading">{title}</h5>
      </If>
      {children}
    </div>
  );
};

const CustomTableSectionHeading = ({
  title = '',
  size = 'lg', // 'lg' | 'md' | 'sm'
  children = null,
  CustomComponent = null,
  customClass = '',
  helpText = '',
  documentationUrl = '',
  titleClassName = '',
  helptextClassName = '',
  extraContentClass = ''
}) => {
  const className = cn('CustomTable-section--heading', customClass);

  if (CustomComponent) {
    return (
      <div className={className}>
        <CustomComponent />
      </div>
    );
  }

  return (
    <div className={cn(className, 'clearfix', 'grid-view')}>
      <div className="head-section">
        <div className="head-section__title">
          <div className={cn('main-title', size, titleClassName)}>{title}</div>
          <InfoLink
            placement="right"
            className="info-icon"
            url={documentationUrl}
          />
        </div>
        <If test={helpText}>
          <div className={cn('help-text', size, helptextClassName)}>
            {helpText}
          </div>
        </If>
      </div>
      <If test={children}>
        <div className={cn('extra-content', extraContentClass)}>{children}</div>
      </If>
    </div>
  );
};

export {
  CustomTable,
  CustomTableRow,
  CustomTableHead,
  CustomTableSection,
  CustomTableSectionHeading,
  CustomTableRows,
  CustomTableFoot,
  CustomTableAddButton,
  Actions,
  ActionsDropdown,
  InfoLink
};
